// extracted by mini-css-extract-plugin
export default {"topSection":"home_topSection__H0t-q","bottomSection":"home_bottomSection__5URa7"};